export const TIME_FOR_TRANSFORM = 400;
export const TIME_FOR_TRANSFORM_MS = `${TIME_FOR_TRANSFORM}ms`;

export const TIME_FOR_OPACITY = 600;
export const TIME_FOR_OPACITY_MS = `${TIME_FOR_OPACITY}ms`;

export const TOKEN_LEADS_COMERCIALES = 'LCV_DDB_FRM_LEM_REC_LEM';
export const TOKEN_LEADS_TURISMOS = 'VW_DDB_FRM_LEM_REC_LEM';
